import { Card } from "./card.model";

export const CARDS: Card[] = [
  { title: 'NUMBER_OF_PAYMENTS_TODAY', uriPath: 'todays-payments-count', routeTo: 'payment_report' },
  { title: 'NUMBER_OF_PAYMENTS_THIS_MONTH', uriPath: 'current-month-payments-count' },
  { title: 'NUMBER_OF_PAYMENTS_THIS_YEAR', uriPath: 'current-year-payments-count' },
  { title: 'NUMBER_OF_TAXPAYERS_WHO_SUBMITTED', uriPath: 'number-of-taxpayers-who-submitted' },
  { title: 'NUMBER_OF_AGENT_ROLE_USERS', uriPath: 'number-of-agents' }
];